enum ChangeFlowVariantEnum {
	SPECIALTY = 'SPECIALTY',
	UNIT = 'UNIT',
	LOCATION = 'LOCATION',
}

export {ChangeFlowVariantEnum};
